console.log('🔥 custom.js loaded');
function switchHotspot() {

  console.log("eeeeeeeeee");
  console.log('🔥 switchHotspot called');
  const variantSelect = document.querySelector('select[name="id"]');
  if (!variantSelect) return;

  const variantId = variantSelect.value;

  console.log('🎯 Active variant:', variantId);

  // ❌ hide ALL hotspots
  document.querySelectorAll('.hotspot-overlay').forEach(el => {
    el.style.display = 'none';
  });

  // ✅ find ACTIVE media
  //const activeMedia = document.querySelector('.product-media--root[data-active="true"]');

let activeMedia = null;

// ✅ check if mobile view is active
const mobileContainer = document.querySelector('.product-page--mobile-container');
const isMobileVisible = window.getComputedStyle(mobileContainer).display !== 'none';
console.log("isMobileVisible", isMobileVisible)
if (isMobileVisible) {
  // 👉 MOBILE: search only inside mobile container
  activeMedia = mobileContainer.querySelector('.product-media--root[data-active="true"]');
} else {
  // 👉 DESKTOP: search only inside desktop container
  const desktopContainer = document.querySelector('.product-page--desktop-container');
  activeMedia = desktopContainer.querySelector('.product-media--root[data-active="true"]');
}


  if (!activeMedia) return;

  // ✅ find hotspot INSIDE active media
  const hotspot = document.querySelector(`.hotspot-overlay[data-variant-id="${variantId}"]`);
  const activeMdiaImage = activeMedia.querySelector('.product-left-image');
  console.log("hotspot", hotspot)
  const zoomEl = activeMedia.querySelector('.product-zoom--enlarged');
  console.log("active hotstpot", hotspot);
//  const hasImage = hotspot?.querySelector('img');
 const hasImage = hotspot?.querySelector('iactiveImg');
  
    console.log("hasImage",hasImage)
 if (hotspot) {
      //activeMdiaImage.insertAdjacentElement('afterend', hotspot);
      activeMedia.appendChild(hotspot);
   hotspot.style.display = 'block';
    activeMdiaImage.style.display = "none";

     console.log('✅ Hotspot rendered (observer)');

} else {
  activeMdiaImage.style.display = "block";
  console.log('❌ No hotspot for this variant');
}
}

document.addEventListener("DOMContentLoaded", function () {
  //console.log('🚀 Page Loaded');

  updateRestockMessage();
//switchHotspot();

 
});
// ✅ VARIANT CHANGE (THIS IS KEY FOR YOUR THEME)
document.addEventListener("change", function () {
    //console.log('🔄 Variant Changed');

    updateRestockMessage();
switchHotspot();

 
});

window.addEventListener('load', () => {
  console.log('✅ Full page loaded');
  switchHotspot();
});

// PDP Apends //
$(window).on("load", function () {
  var pdpMContent = $(".pdp-move-terms").html(); // Get HTML content of pdp-m
  $(".pdp-terms").append(pdpMContent); // Append pdp-m content to pdp-y
  $(".pdp-move-terms").remove(); // Remove pdp-m after appending its content
});

// PDP features //
const selectHotspot = (e) => {
  e.stopPropagation(); // Stop the click event from propagating to the document
  const clickedHotspot = e.target.closest(".lg-hotspot");
  const container = clickedHotspot.parentElement;
  const hotspots = container.querySelectorAll(".lg-hotspot");
  hotspots.forEach((hotspot) => {
    if (hotspot === clickedHotspot) {
      hotspot.classList.toggle("lg-hotspot--selected");
    } else {
      hotspot.classList.remove("lg-hotspot--selected");
    }
  });
};
const closeHotspots = () => {
  const hotspots = document.querySelectorAll(".lg-hotspot");
  hotspots.forEach((hotspot) => {
    hotspot.classList.remove("lg-hotspot--selected");
  });
};
(() => {
  const buttons = document.querySelectorAll(".lg-hotspot__button");
  buttons.forEach((button) => {
    button.addEventListener("click", selectHotspot);
  });
  document.addEventListener("click", closeHotspots);
})();

// PDP thumbnails //
$(".proThumbSlide").slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
});
$(".proThumbSlide").on('afterChange', function(event, slick, currentSlide, nextSlide){
  var arrowLeft = $('.slick-prev');
  var arrowRight = $('.slick-next');
  // Hide left arrow if on the first slide
  if (currentSlide === 0) {
    arrowLeft.css('display', 'none');
  } else {
    arrowLeft.css('display', 'block');
  }
  // Hide right arrow if on the last slide
  if (currentSlide + slick.options.slidesToShow >= slick.slideCount) {
    arrowRight.css('display', 'none');
  } else {
    arrowRight.css('display', 'block');
  }
});// Restock message toggle when variant radio changes
function updateRestockMessage(){

  const variantSelect = document.querySelector('select[name="id"]');
  if(!variantSelect) return;

  const selectedOption = variantSelect.options[variantSelect.selectedIndex];

  const restockDate = selectedOption.dataset.restock;
  const inventoryQty = selectedOption.dataset.quantity;
  const qty = parseInt(inventoryQty || "0");

  //const restockBox = document.getElementById("restock-message");
  const button = document.querySelector('.product-buy-buttons--cta-text');
  if(!button) return;

 if(qty <= 0){

    if(restockDate){
        // WITH DATE
        button.innerHTML = "OUT OF STOCK – Available " + restockDate;
    } else {
        // NO DATE
        button.innerHTML = "OUT OF STOCK";
    }

}else{
    button.innerHTML = "ADD TO CART";
}
}
// This is for Hotspot 


function controlModal() {
  const variantId = document.querySelector('select[name="id"]')?.value;
  const hotspotId = window.variantHotspots?.[variantId];

  const activeMedia = document.querySelector('.product-media--root[data-active="true"]');
  if (!activeMedia) return;

  const modalTrigger = activeMedia.querySelector('.product-media--modal');
  if (!modalTrigger) return;

  // store original
  if (!modalTrigger.dataset.originalIndex) {
    modalTrigger.dataset.originalIndex = modalTrigger.getAttribute('data-index');
  }

  if (hotspotId) {
    console.log('🔥 Disable modal-trigger');

    modalTrigger.removeAttribute('data-index');
    modalTrigger.removeAttribute('data-id');
    modalTrigger.removeAttribute('tabindex');
    modalTrigger.style.cursor = "pointer";

  } else {
    console.log('✅ Enable modal-trigger');

    modalTrigger.setAttribute('data-id', 'product');
    modalTrigger.setAttribute('data-index', modalTrigger.dataset.originalIndex);
    modalTrigger.setAttribute('tabindex', '0');
  }
}

// Jit : This is For Thumb Click Open the Modal with Gallery 

document.addEventListener('click', function (e) {

  const thumb = e.target.closest('.product-media--thumb');
  if (!thumb) return;
  const mediaId = thumb.dataset.id;
   switchThumb(thumb.dataset.id);
  const modalId = "product";

  function openModal() {
    const modal = theme.modal.instances[modalId];
    if (!modal) return;

    const targetView = document.querySelector(`.modal--view[data-id="${mediaId}"]`);
    if (!targetView) {
      console.log('❌ No matching modal view');
      return;
    }

    const index = parseInt(targetView.dataset.modalIndex);

    console.log('✅ Opening modal at index:', index);

    // ✅ switch image
    modal.toggleView(index, false);

    // ✅ open modal (fixed)
    const modalEl = document.querySelector('modal-root[data-id="product"]');
    if (!modalEl) return;

    modalEl.setAttribute("aria-hidden", "false");
    modalEl.setAttribute("data-transition-active", "true");

    document.body.classList.add('modal-open');
  }

  if (window.theme?.modal?.instances?.[modalId]) {
    openModal();
  } else {
    const interval = setInterval(() => {
      if (theme?.modal?.instances?.[modalId]) {
        clearInterval(interval);
        openModal();
      }
    }, 100);
  }

});

document.addEventListener('click', function (e) {

  const thumb = e.target.closest('.modal-thumb');
  if (!thumb) return;

 

  // ✅ STOP redirect
  e.preventDefault();
  e.stopPropagation();

  const mediaId = thumb.dataset.id;

  // ❌ remove active from all images
  document.querySelectorAll('.modal--view').forEach(view => {
    view.classList.remove('active');
  });

  // ✅ show correct image
  const target = document.querySelector(`.modal--view[data-id="${mediaId}"]`);
  if (target) {
    target.classList.add('active');
  }

  // ❌ remove active from all thumbs
  document.querySelectorAll('.modal-thumb').forEach(t => {
    t.classList.remove('active');
  });

  // ✅ highlight clicked thumb
  thumb.classList.add('active');

});


// ✅ DEFAULT ACTIVE IMAGE ON LOAD
document.addEventListener('DOMContentLoaded', function () {
  const firstView = document.querySelector('.modal--view');
  const firstThumb = document.querySelector('.modal-thumb');

  if (firstView) firstView.classList.add('active');
  if (firstThumb) firstThumb.classList.add('active');
});

// ✅ Close modal on background click
document.addEventListener('click', function (e) {
  const modalEl = document.querySelector('modal-root[data-id="product"]');
  const closebtn = document.querySelector('button.layout--close');
  console.log("closebtn",closebtn);
  if (!modalEl) return;
  console.log(e.target)
  // click outside image
  if (e.target === modalEl) {
    switchHotspot();
    modalEl.setAttribute("aria-hidden", "true");
    modalEl.removeAttribute("data-transition-active");
    document.body.classList.remove('modal-open');
  }
});

// ✅ Close on ESC key
document.addEventListener('keydown', function (e) {

  if (e.key === "Escape") {
      switchHotspot();
    const modalEl = document.querySelector('modal-root[data-id="product"]');
    if (!modalEl) return;

    modalEl.setAttribute("aria-hidden", "true");
    modalEl.removeAttribute("data-transition-active");
    document.body.classList.remove('modal-open');
  }
});
//window.fetch = () => Promise.resolve(new Response(null, { status: 204 }));

function switchThumb(thumb_id) {
    // ❌ hide ALL hotspots
  document.querySelectorAll('.hotspot-overlay').forEach(el => {
    el.style.display = 'none';
  });
let activeMedia = null;
// ✅ check if mobile view is active
const mobileContainer = document.querySelector('.product-page--mobile-container');
const isMobileVisible = window.getComputedStyle(mobileContainer).display !== 'none';
//console.log("isMobileVisible", isMobileVisible)
if (isMobileVisible) {
  // 👉 MOBILE: search only inside mobile container
  activeMedia = mobileContainer.querySelector('.product-media--root[data-active="true"]');
} else {
  // 👉 DESKTOP: search only inside desktop container
  const desktopContainer = document.querySelector('.product-page--desktop-container');
  activeMedia = desktopContainer.querySelector('.product-media--root[data-active="true"]');
}
//console.log("activeMedia", activeMedia);
  if (!activeMedia) return;
  const activeMediaId = activeMedia?.getAttribute('data-id');
//console.log('📸 Active media ID:', activeMediaId);
  // ✅ find hotspot INSIDE active media
  let hotspot = activeMedia.querySelector(
  `.hotspot-overlay[data-id="${activeMediaId}"]`
);
//console.log(hotspot);
const hotspotMediaId = hotspot?.getAttribute('data-id');
//console.log('📸 Active media ID:', hotspotMediaId);
if(hotspot){
  hotspot.style.display = "block";
}
}